var map = {
	"./feedback.png": 708,
	"./feedback.svg": 709,
	"./leak_blue.gif": 710,
	"./leak_blue.png": 711,
	"./leak_blue_old.png": 712,
	"./leak_green.gif": 713,
	"./leak_green.png": 714,
	"./leak_green_old.png": 715,
	"./leak_green_static.png": 716,
	"./leak_red.gif": 717,
	"./leak_red_anim.gif": 718,
	"./leak_red_old.gif": 719,
	"./leak_red_old.png": 720,
	"./pin_blue.png": 721,
	"./pin_green.png": 722,
	"./pin_red.png": 723,
	"./place.png": 724,
	"./place.svg": 725,
	"./place_blue.png": 726,
	"./place_green.png": 727,
	"./place_green.svg": 728,
	"./place_red.gif": 729,
	"./place_red.svg": 730,
	"./place_red_old.png": 731,
	"./place_yellow.png": 732
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 762;


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons ^\.\/.*$
// module id = 762
// module chunks = 6